import type * as React from 'react';

import { Box, CircularProgress, Stack, Typography } from '@mui/material';

interface FullPageSpinnerProps {
  label?: string;
}

// Center-screen spinner used by AuthGate during the OIDC bootstrap and by
// the data-loading placeholder. Fills the viewport — never inside a card.
export const FullPageSpinner = ({ label }: FullPageSpinnerProps): React.JSX.Element => (
  <Box
    sx={{
      display: 'flex',
      width: '100vw',
      height: '100vh',
      alignItems: 'center',
      justifyContent: 'center',
      bgcolor: 'background.default',
    }}
  >
    <Stack spacing={2} alignItems="center">
      <CircularProgress color="primary" />
      {label ? (
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
      ) : null}
    </Stack>
  </Box>
);
